// extracted by mini-css-extract-plugin
export default {"cls1":"_fJ5972z1l3OyjQzAYlf","cls2":"pMkdHaeAzAq96tvN6CBI _fJ5972z1l3OyjQzAYlf"};